export default __webpack_public_path__ + "files/55d77b94009ea98824ee008af39dedb2.png";